import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE = {
	customer1: 'Customer1',
	customer2: 'Customer2',
	witness1: 'Witness1',
	witness2: 'Witness2',
	dateYear: 'year',
	date2On: 'day',
	dateMonth: 'month',
	dateDay: 'date',
	landlordName: 'landlordName',
	from: 'borrowerName',
	address: 'address',
	re: 'mobileHomeDescription',
	srf: 'SRF',
	srf2: 'SRF2',
	dated2At: 'datedAt',
	date2Year: 'year2',
};

export interface RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE {
	dateDay: string;
	dateMonth: string;
	dateYear: string;
	from: string;
	re: string;
	address: string;
	srf: string;
	srf2: string;
	landlordName: string;

	dated2At: string;
	date2On: string;
	date2Year: string;

	witness1: string;
	witness2: string;

	customer1: string;
	customer2: string;
	// lenderReferenceNumber: string,
	// date: string,
	// mortgagors:string,
	// guarantors:string,

	// propertyCity: string,
	// // propertyProvince: string,
	// // propertyPostalCode: string,

	// mortgageAmount:string,
	// mortgageRegistrationNumber:string,
	// mortgageRegistrationDate:string,
	// taxesPaidInFullDate:string,
	// taxesPropertyCode:string,
	// titleOpinion:string,
	// titleInsuranceReferenceNumber:string,
	// titleInsurerName:string,
	// lawyerName:string,
	// exceptions:string,

	// bankTitle:string,
	// reportType:string,

	// checkDocument:string,
	// checkPolicy:string,
	// checkProtocol:string
}
